/**
 * Catégories d'erreur métier. Le back les traduit en codes HTTP dans un unique filtre,
 * le front les traduit en comportement d'UI. Aucun des deux ne connaît le code de l'autre.
 */
export const ERROR_CATEGORIES = [
    'invalid',
    'authentication',
    'forbidden',
    'not_found',
    'conflict',
    'locked',
    'unavailable',
];
/** Codes que le front interprète au lieu de se contenter d'afficher le message. */
export const ERROR_CODES = {
    /** Anti-biais : il faut valider sa propre note avant de voir celles des autres. */
    OWN_TASTING_REQUIRED: 'OWN_TASTING_REQUIRED',
    /** La séance est close, l'écriture est refusée. */
    SESSION_CLOSED: 'SESSION_CLOSED',
    /** La séance n'est pas encore lancée : les notes ne sont pas encore recevables. */
    SESSION_NOT_OPEN: 'SESSION_NOT_OPEN',
    /** Le serveur détient une version plus récente : la file offline abandonne l'entrée. */
    STALE_WRITE: 'STALE_WRITE',
    /** Le pronostic est déjà verrouillé. */
    GUESS_LOCKED: 'GUESS_LOCKED',
    INVITATION_EXPIRED: 'INVITATION_EXPIRED',
    INVITATION_ALREADY_USED: 'INVITATION_ALREADY_USED',
    PSEUDO_TAKEN: 'PSEUDO_TAKEN',
    GUEST_LIMIT_REACHED: 'GUEST_LIMIT_REACHED',
};
//# sourceMappingURL=errors.js.map